{
  "title": "Conjure Woodland Beings",
  "source": "Player's Handbook",
  "levelAndSchool": "4th-level conjuration",
  "level": 4,
  "castingTime": "1 action",
  "range": "60 feet",
  "components": "V, S, M (one holly berry per creature summoned)",
  "duration": "Concentration, up to 1 hour",
  "description": [
    "You summon fey creatures that appear in unoccupied spaces that you can see within range. Choose one of the following options for what appears:",
    "One fey creature of challenge rating 2 or lower",
    "Two fey creatures of challenge rating 1 or lower",
    "Four fey creatures of challenge rating 1/2 or lower",
    "Eight fey creatures of challenge rating 1/4 or lower",
    "A summoned creature disappears when it drops to 0 hit points or when the spell ends.",
    "The summoned creatures are friendly to you and your companions. Roll initiative for the summoned creatures as a group, which have their own turns. They obey any verbal commands that you issue to them (no action required by you). If you don’t issue any commands to them, they defend themselves from hostile creatures, but otherwise take no actions. The DM has the creatures’ statistics.",
    "At Higher Levels. When you cast this spell using certain higher-level spell slots, you choose one of the summoning options above, and more creatures appear: twice as many with a 6th-level slot, and three times as many with an 8th-level slot."
  ],
  "spellLists": ["druid", "ranger"]
}
